import { Interceptor } from "./interceptor";
import {
  showErrorMessage,
  serializeQueryParams,
  checkStatus,
  createRequest,
  parseJSON,
  isKFDomain
} from "./utils";
import { Queue } from "./queue";

let abortRequestList = {};

export const cancelDataServiceRequestByKey = (key) => {
  const pendingComponentAbortList = abortRequestList[key];
  if (pendingComponentAbortList) {
    pendingComponentAbortList.map((data) => data.abort());
    //clearing fetch list for that key
    abortRequestList[key] = [];
  }
};

//adding default interceptors
Interceptor.addInterceptor({
  responseError: async (error) => {
    if (error && !error?.statusCode) {
      const { i18n } = await import("base/i18n");
      const { i18nMark } = await import("@lingui/react");

      const offlineMessage = i18nMark(
        "Looks like your network connection is unstable. Some actions might fail."
      );
      return Promise.reject({
        name: "Offline",
        message: i18n._(offlineMessage)
      });
    }
    return Promise.reject(error);
  }
});
Interceptor.addInterceptor({ response: checkStatus });
Interceptor.addInterceptor({ response: parseJSON });

export const sendRequest = (url, options) => {
  let controller = new AbortController();
  options.signal = controller.signal;
  if (
    options.hasOwnProperty("cancelPendingRequestkey") &&
    options.cancelPendingRequestkey
  ) {
    abortRequestList[options.cancelPendingRequestkey] = abortRequestList[
      options.cancelPendingRequestkey
    ]
      ? [...abortRequestList[options.cancelPendingRequestkey], controller]
      : [controller];
  }
  let promise = async function gettingRequest() {
    let request = await createRequest(url, options);
    return Interceptor.fetch(request).catch((err) => {
      if (options.method !== "GET") {
        let showToast = options.hasOwnProperty("toast") ? options.toast : true;
        if (err.name !== "Offline") {
          showToast && showErrorMessage(err);
        }
      }
      return Promise.reject(err);
    });
  };
  return [promise, () => controller.abort()];
};

const SERVICE = {
  get: (url, options = {}) => {
    options.method = "GET";
    return sendRequest(url, options);
  },

  post: (url, options = {}) => {
    options.method = options.method || "POST";
    return sendRequest(url, options);
  },

  update: function updateService(url, options = {}) {
    options.method = "PUT";
    return this.post(url, options);
  },

  patch: (url, options = {}) => {
    options.method = "PATCH";
    return sendRequest(url, options);
  },

  delete: (url, options = {}) => {
    options.method = "DELETE";
    return sendRequest(url, options);
  },

  postq: (url, options = {}, callback = () => false, queueName = "default") => {
    let queue = Queue.getQueue(queueName);
    options.method = "POST";
    return queue.queueRequest(url, options, callback);
  },

  fetch: (url, options = {}) => {
    options = Object.assign({ method: "GET" }, options);
    let request = createRequest(url, options);
    return fetch(request).then(checkStatus);
  },
  upload(url, options = {}) {
    if (options.query) {
      url = serializeQueryParams(url, options.query);
    }
    if (isKFDomain(url)) {
      options.headers["X-Csrf-Token"] = window.accountDetails?.AuthToken;
    }
    return fetch(url, options)
      .then(checkStatus)
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  xhrRequest: (url) => {
    // new rqeuest
    let req = new XMLHttpRequest();
    req.open("GET", url, true);
    //crsf token
    const { AuthToken } = window.accountDetails;
    if (AuthToken) {
      req.setRequestHeader("X-Csrf-Token", AuthToken);
    }
    req.responseType = "blob";
    req.send();
    return req;
  },

  download: (url) => {
    return fetch(url)
      .then(checkStatus)
      .then((response) => response.blob())
      .catch((err) => {
        return Promise.reject(err);
      });
  }
};

export const DataService = SERVICE;
